import { DarkMode, LightMode } from "@mui/icons-material";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import { handleThemeModeChange, useMicrospecThemeLanguageContext } from "../../Themes";

interface MicrospecThemeModePickerProps {
    size?: "small" | "medium" | "large";
}

const MicrospecThemeModePicker: React.FC<MicrospecThemeModePickerProps> = ({ size = "large" }) => {
    const { localizationProvider } = useMicrospecThemeLanguageContext();
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const handleToggle = () => {
        handleThemeModeChange();
    };

    return (
        <Tooltip
            title={localizationProvider.translateByType({
                type: "Internal",
                text: isDarkMode ? "lightMode" : "darkMode"
            })}
        >
            <IconButton
                id="theme-mode-picker"
                size={size}
                aria-label="toggle theme mode"
                color={isDarkMode ? 'inherit' : 'primary'}
                sx={{
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        color: isDarkMode ? theme.palette.primary.light : theme.palette.primary.main,
                        backgroundColor: `${theme.palette.action.hover}15`,
                        transform: 'scale(1.1)',
                        boxShadow: `0 4px 15px ${isDarkMode ? theme.palette.primary.light : theme.palette.primary.main}30`
                    }
                }}
                onClick={handleToggle}
            >
                {isDarkMode ? <LightMode /> : <DarkMode />}
            </IconButton>
        </Tooltip>
    );
};

export default MicrospecThemeModePicker;
